<template>
	<div class="surebg">
		<div class="reservetop">
			<p>{{$t('ReserveCar.ReserveCar_1')}}</p>
			<span>{{$t('ReserveCar.ReserveCar_2')}}</span>
		</div>
		<div class="reservebg">
			<el-form ref="ruleForm" :rules="rules" :model="form" :disabled="formDIS">
				<el-form-item :label="$t('ReserveCar.ReserveCar_3')">
					<div class="reservelab row">
						<el-image style="" :src="url" fit="contain"></el-image>
						<span>{{carname}}</span>
					</div>
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_4')">
					{{form.timedata}}
				</el-form-item>



				<el-form :rules="rules" :model="form" ref="ruleForm2">
					<el-form-item :label="$t('ReserveCar.ReserveCar_19')" prop="zysx">
						<el-radio-group class="zysxlabel" v-model="form.zysx" @change="zysxChange">
							<el-radio :label="'0'" style=" white-space:normal;">{{$t('ReserveCar.ReserveCar_38')}}
							</el-radio>
							<el-radio :label="'1'" style=" white-space:normal;">{{$t('ReserveCar.ReserveCar_34')}}
							<span style=" color: #F56C6C;display: block;float: right;">{{$t('ReserveCar.ReserveCar_77')}}</span>
							</el-radio>
						</el-radio-group>
						<div><span
								style="font-size: 12px; color: #F56C6C;display: block;line-height: 16px; margin-bottom: 6px;"
								v-if="zysxText">
								{{$t('ReserveCar.ReserveCar_39')}}
							</span>
							<span
								style="font-size: 12px; color: #F56C6C;line-height: 16px;display: block;">{{$t('ReserveCar.ReserveCar_54')}}</span>
						</div>
					</el-form-item>



					<el-form-item class="dddtime" :label="$t('ReserveCar.ReserveCar_5')" prop="value1">

						<el-col class="row yxtime ">
							<!-- <el-time-picker :clearable="false" value-format="HH:mm" format="HH:mm"
							:placeholder="form.value1" v-model="form.value1" style="width: 100%;">
						</el-time-picker> -->
							<el-form-item prop="hours">
								<el-select v-model="form.hours" placeholder="" @change="hourChange">
									<el-option v-for="(item,index) in hourslist" :label="item.label" :value="item.label"
										:key="index">
									</el-option>
								</el-select>
							</el-form-item>

							<span style="line-height: 60px;margin:0 10px">:</span>
							<el-form-item prop="mins">
								<el-select v-model="form.mins" placeholder="">
									<el-option v-for="(item,index) in minslist" :label="item.label" :value="item.label"
										:key="index">
									</el-option>
								</el-select>
							</el-form-item>

						</el-col>
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_6')" prop="typeid">
						<el-col :span="24">
							<el-radio-group v-model="form.typeid" @change="getTIME">
								<el-radio :label="item.INIKEY02" name="type" v-for="(item,index) in typelist"
									:key="index" :disabled="item.dispshow=='true'?false:true">
									{{item.INIVALUE1}}
								</el-radio>
								<!-- <el-radio :label="6" name="type">6h（¥18,000）</el-radio>
						<el-radio :label="9" name="type">9h（¥18,000）</el-radio>
						<el-radio :label="24" name="type">24h（¥18,000）</el-radio> -->
							</el-radio-group>
						</el-col>
						
						<span style="font-size: 12px; color: #F56C6C;line-height: 16px;display: block;">
						<div>{{$t('ReserveCar.ReserveCar_59')}}</div>
						<div>{{$t('ReserveCar.ReserveCar_65')}}</div>
						</span>
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_7')">
						<el-checkbox v-model="form.checked" :disabled="addday!=''?false:true" @change="adddayChange">
						</el-checkbox>

						<span style="line-height: 60px;margin:0 10px"> </span>
						<el-select v-model="form.ckaddday" :disabled="readeraddday" placeholder=""
							@change="ckadddayChange">
							<el-option :label="item.DATE" :value="item.DAY" v-for="(item,index) in ckadddaylist"
								:key="index">{{item.DATE}}</el-option>
						</el-select>
						<span style="line-height: 60px;margin:0 10px"> </span>
						{{$t('ReserveCar.ReserveCar_20')}}￥{{daymoneyformater}}
					</el-form-item>

					<el-form-item :label="$t('ReserveCar.ReserveCar_8')" prop="region">
						<!-- <el-col :span="24"> -->
						<el-select v-model="form.region" placeholder="">
							<el-option v-for="(item,index) in regionoptions" :label="item.label" :value="item.label"
								:key="index">
							</el-option>
						</el-select>
						<!-- <el-input v-model="form.region" :max="personnum" placeholder="" type="number"></el-input> -->
						<!-- </el-col> -->
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_9')" prop="pernum">
						<!-- <el-col :span="24"> -->
						<el-select v-model="form.pernum" placeholder="">
							<el-option v-for="(item,index) in pernumoptions" :label="item.label" :value="item.label"
								:key="index">
							</el-option>
						</el-select>
						<!-- <el-input v-model="form.pernum" placeholder="" type="number"></el-input> -->
						<!-- </el-col> -->
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_10')" prop="name">
						<el-col :span="16">
							<el-input v-model="form.name" placeholder="山田 / Yamada"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_11')" prop="secondname">
						<el-col :span="16">
							<el-input v-model="form.secondname" placeholder="太郎 / Taro"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_12')" prop="tel">
						<el-col :span="16">
							<el-input v-model="form.tel" placeholder="09012345678"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_13')" prop="email">
						<el-col :span="16">
							<el-input v-model="form.email" placeholder="mail@mrhiro.co.jp"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_14')" prop="suremail">
						<el-col :span="16">
							<el-input v-model="form.suremail" placeholder="mail@mrhiro.co.jp"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_15')" prop="contray">
						<!-- <el-col :span="16"> -->
						<el-select v-model="form.contray" placeholder="" @change="COYIDChange">
							<el-option :label="item.INIVALUE" :value="item.INIKEY02" v-for="(item,index) in contrylist"
								:key="index">{{item.INIVALUE}}</el-option>
						</el-select>
						<!-- </el-col> -->
					</el-form-item>
					<div>
						<el-form-item :label="$t('ReserveCar.ReserveCar_67')">
							<el-checkbox v-model="form.photo1">
								{{$t('ReserveCar.ReserveCar_68')}}
							</el-checkbox>
							<el-checkbox v-model="form.photo2">
								{{$t('ReserveCar.ReserveCar_69')}}
							</el-checkbox>
								<el-checkbox v-model="form.photo3">
									{{$t('ReserveCar.ReserveCar_73')}}
								</el-checkbox>
							{{$t('ReserveCar.ReserveCar_74')}}
							<div class="button-group;float: right;width:50%;">
								<el-button @click="openCarousel()" class="fixed-button"
									　style="background-color: #000; border-color: #000;">
									<div class="btntext1" style="font-size: 14px;">
										{{$t('ReserveCar.ReserveCar_70')}}
									</div>
								</el-button>
							</div>
								<div class="button-group;float: left;width:50%;">
								<el-button @click="showVideoModal = true" class="fixed-button"
									　style="background-color: #000; border-color: #000;">
									<div class="btntext1" style="font-size: 14px;">
										{{$t('ReserveCar.ReserveCar_71')}}
									</div>
								</el-button>
							</div>
							<div>
								<span style="font-size: 12px; color: #F56C6C;line-height: 16px;display: block;">
									<p>{{$t('ReserveCar.ReserveCar_75')}}</p>
									<p>{{$t('ReserveCar.ReserveCar_76')}}</p>
								</span>
							</div>
						</el-form-item>
					</div>

					<el-form-item :label="$t('ReserveCar.ReserveCar_16')" prop="resource">
						<el-radio-group v-model="form.resource" @change="resourceChange">
							<el-radio style=" white-space:normal;" :label="item.INIKEY02" v-for="(item,index) in KKDT"
								:key="item.INIKEY02">{{item.INIVALUE}}</el-radio>
							<!-- <el-radio style=" white-space:normal;" :label="$t('ReserveCar.ReserveCar_22')"></el-radio>
						<el-radio style=" white-space:normal;" :label="$t('ReserveCar.ReserveCar_23')"></el-radio>
						<el-radio style=" white-space:normal;" :label="$t('ReserveCar.ReserveCar_24')"></el-radio> -->
						</el-radio-group>

						<span style="font-size: 12px; color: #F56C6C;" v-if="resourcecText">
							{{resourcecMsg}}
						</span>

					</el-form-item>




					<el-form-item :label="$t('ReserveCar.ReserveCar_17')" prop="bxid">
						<el-radio-group v-model="form.bxid" class="bxbg">
							<el-radio :label="item.INIKEY02" name="type" :disabled="item.INIDIS"
								v-for="(item,index) in bxlist" :key="index">
								{{item.INIVALUE}}
							</el-radio>
							<!-- <el-radio :label="$t('bx.bx_2')" name="type"></el-radio>
						<el-radio :label="$t('bx.bx_3')" name="type"></el-radio> -->
						</el-radio-group>
						<div class="bxtc">
							<p>{{$t('bx.bx_4')}}</p>
							<div class="bxtxitem" v-if="form.bxid == bxlist_0.INIKEY02">
								<div class="bxrow">
									<p>{{$t('bx.bx_5')}}<span>{{$t('bx.bx_6')}}</span></p>
									<p>{{$t('bx.bx_7')}}<span>{{$t('bx.bx_8')}}</span></p>
								</div>
								<div class="bxrow">
									<p>{{$t('bx.bx_9')}}<span>{{$t('bx.bx_10')}}</span></p>
									<p>{{$t('bx.bx_11')}}<span>{{$t('bx.bx_6')}}</span></p>
								</div>
								<div class="bxtxred">
									※{{$t('bx.bx_21')}}
								</div>
							</div>
							<div class="bxtxitem" v-if="form.bxid == '9'">
								<div class="bxrow">
									<p>{{$t('bx.bx_5')}}<span>{{$t('bx.bx_6')}}</span></p>
									<p>{{$t('bx.bx_7')}}<span>{{$t('bx.bx_19')}}</span></p>
								</div>
								<div class="bxrow">
									<p>{{$t('bx.bx_9')}}<span>{{$t('bx.bx_10')}}</span></p>
									<p>{{$t('bx.bx_11')}}<span>{{$t('bx.bx_6')}}</span></p>
								</div>
							</div>
							<div class="bxtxitem" v-if="form.bxid == bxlist_1.INIKEY02">
								<div class="bxrow">
									<p>{{$t('bx.bx_5')}}<span>{{$t('bx.bx_6')}}</span></p>
									<p>{{$t('bx.bx_7')}}<span>{{$t('bx.bx_6')}}</span></p>
								</div>
								<div class="bxrow">
									<p>{{$t('bx.bx_9')}}<span>{{$t('bx.bx_6')}}</span></p>
									<p>{{$t('bx.bx_11')}}<span>{{$t('bx.bx_6')}}</span></p>
								</div>
							</div>
							<div class="bxtxitem" v-if="form.bxid ==bxlist_2.INIKEY02">
								<div class="bxrow">
									<p>{{$t('bx.bx_5')}}<span>{{$t('bx.bx_6')}}</span></p>
									<p>{{$t('bx.bx_7')}}<span>{{$t('bx.bx_19')}}</span></p>
								</div>
								<div class="bxrow">
									<p>{{$t('bx.bx_9')}}<span>{{$t('bx.bx_10')}}</span></p>
									<p>{{$t('bx.bx_11')}}<span>{{$t('bx.bx_6')}}</span></p>
								</div>
							</div>
							<div class="bxtxred">※{{$t('bx.bx_12')}}</div>
							<el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%;"
								:show-header="false">
								<el-table-column prop="id" label="">
								</el-table-column>
								<el-table-column prop="name" label="">
								</el-table-column>
								<el-table-column prop="amount1" label="" width="160">
								</el-table-column>
							</el-table>
							<div class="bxtxredtext">
								{{$t('bx.bx_13')}}
							</div>
						</div>
					</el-form-item>

					<el-form-item :label="$t('ReserveCar.ReserveCar_64')" prop="Reviewing">
						<p>{{$t('ReserveCar.ReserveCar_60')}}</p>

						<el-checkbox v-model="form.Reviewing">

							<p>{{$t('ReserveCar.ReserveCar_62')}}</p>

						</el-checkbox>
						{{Reviewing1}}
						<p>{{$t('ReserveCar.ReserveCar_66')}}</p>
						<el-checkbox v-model="form.Reviewing" prop="Reviewing">
							<p>{{$t('ReserveCar.ReserveCar_63')}}</p>
						</el-checkbox>
					</el-form-item>
				</el-form></el-form>

			<el-button class="carlinbn row" :disabled="formDIS" @click="Reservesure()">
				<div>
					<img src="@/assets/default/calendatJT.png" alt="">
				</div>
				<div class="btntext">
					{{$t('ReserveCar.ReserveCar_35')}}
				</div>
				<!-- <p></p> -->
			</el-button>
			<!-- 			<el-button :class="form.zysx!=''?'carlinbn row f-b':'graybg carlinbn row f-b'"
				:disabled="form.zysx!=''?false:true" @click="Reservesure()">
				<p>{{$t('ReserveCar.ReserveCar_35')}}</p>
				<img src="@/assets/default/calendatJT.png" alt="">
			</el-button> -->
		</div>



		<el-dialog :visible.sync="jpdialog" append-to-body>
			<p>
				{{$t('ReserveCar.ReserveCar_41')}}
			</p>
			<p> {{$t('ReserveCar.ReserveCar_42')}} </p>
			<p>{{$t('ReserveCar.ReserveCar_43')}} </p>
			<p>{{$t('ReserveCar.ReserveCar_44')}} </p>
			<p>{{$t('ReserveCar.ReserveCar_45')}} </p>
			<p>{{$t('ReserveCar.ReserveCar_46')}} </p>
		</el-dialog>


		<el-dialog :visible.sync="gjfialog" append-to-body>
			<p>
				{{Gjtext}}
			</p>
			<p> {{$t('ReserveCar.ReserveCar_48')}} </p>
			<p>{{$t('ReserveCar.ReserveCar_49')}} </p>
			<p>{{$t('ReserveCar.ReserveCar_50')}} </p>
			<p>{{$t('ReserveCar.ReserveCar_51')}} </p>
			<p>{{$t('ReserveCar.ReserveCar_52')}} </p>
			<p>{{$t('ReserveCar.ReserveCar_53')}} </p>
		</el-dialog>

		<!-- 未登录时弹窗 -->
		<div class="image-carousel-wrapper" v-if="isOpen">
			<!-- 新增的关闭按钮 -->
			<button class="close-button" @click="closeCarousel">×</button>

			<div class="image-carousel">
				<button class="nav-button prev" @click="prevImage">❮</button>

				<div class="image-container">
					<img v-for="(image, index) in images" :key="image.MDQCNTNO" :src="image.MDQMLINK"
						:class="{ active: currentIndex === index }" class="carousel-image">
				</div>

				<button class="nav-button next" @click="nextImage">❯</button>
			</div>
		</div>

		<div>
			<!-- 视频弹窗 -->
			<el-dialog :visible.sync="showVideoModal" :fullscreen="isMobile" width="80%" top="5vh"
				custom-class="video-dialog" @close="pauseVideo">
				<div class="video-container">
					<div class="video-wrapper">
						<video ref="videoPlayer" controls class="responsive-video" @loadedmetadata="adjustVideoSize">
							<source :src="localVideoUrl" type="video/mp4">
							您的浏览器不支持HTML5视频
						</video>
					</div>
					<div v-if="loading" class="loading-indicator">
						<el-icon class="loading-icon"><el-icon-loading /></el-icon>
						视频加载中...
					</div>
				</div>
			</el-dialog>
		</div>

	</div>
</template>


<script>
	export default {
		name: 'ReserveCar',
		inject: ['reload'],
		components: {

		},
		data() {
			// const validatevalue1 = (rule, value, callback) => { //时间
			// 	if (value === '') {
			// 		callback(new Error(this.$t('bc.bc_10')));

			// 	} else {
			// 		callback();
			// 	}
			// };
			const validatehours = (rule, value, callback) => { //小时
				if (value === '') {
					callback(new Error(this.$t('bc.bc_10')));

				} else {
					callback();
				}
			};
			const validatemins = (rule, value, callback) => { //分钟
				if (value === '') {
					callback(new Error(this.$t('bc.bc_10')));

				} else {
					callback();
				}
			};
			const validatetypeid = (rule, value, callback) => { //时间
				if (value === '') {
					callback(new Error(this.$t('bc.bc_11')));

				} else if (value === undefined) {
					callback(new Error(this.$t('bc.bc_11')));

				} else {
					callback();
				}
			};
			// const validateregion = (rule, value, callback) => { //乘车人数
			// 	if (value === '') {
			// 		callback(new Error(this.$t('bc.bc_12')));

			// 	} else if (value < 1) {
			// 		callback(new Error(this.$t('bc.bc_33')));
			// 	} else if (value > this.personnum) {
			// 		callback(new Error(this.$t('bc.bc_25')));
			// 	} else {
			// 		callback();
			// 	}
			// };
			const validatename = (rule, value, callback) => { //姓
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				// console.log(isok)
				if (value === '') {
					callback(new Error(this.$t('bc.bc_2')));

				} else if (isok) {
					callback(new Error(this.$t('bc.bc_2')));

				} else {
					callback();
				}
			};
			const validatesecondname = (rule, value, callback) => { //名
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				if (value === '') {
					callback(new Error(this.$t('bc.bc_3')));

				} else if (isok) {
					callback(new Error(this.$t('bc.bc_3')));

				} else {
					callback();
				}
			};
			const validatetel = (rule, value, callback) => { //电话
				var tels = (/^[0-9]{8,13}$/)
				let isok = tels.test(value)
				if (value === '') {
					callback(new Error(this.$t('bc.bc_1')));

				} else if (!isok) {
					callback(new Error(this.$t('bc.bc_47')));
				} else {
					callback();
				}
			};
			const validateemail = (rule, value, callback) => { //邮箱
				if (value === '') {
					callback(new Error(this.$t('UserInfo.UserInfo_23')));

				}
				var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
				let isok = reg.test(value);
				console.log(isok)
				if (!isok) {
					callback(new Error(this.$t('Register.Register_lbl13')));
				} else {
					callback();
				}
			};
			const validatesuremail = (rule, value, callback) => { //邮箱

				var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
				let isok = reg.test(value);
				console.log(isok)
				if (value === '') {
					callback(new Error(this.$t('bc.bc_13')));
				} else if (!isok) {
					callback(new Error(this.$t('Register.Register_lbl13')));
				} else if (value !== this.form.email) {
					callback(new Error(this.$t('bc.bc_14')));
				} else {
					callback();
				}
			};
			const validateReviewing = (rule, value, callback) => { //利用規約確認
				if (value === false) {
					callback(new Error(this.$t('bc.bc_56')));
				} else {
					callback();
				}
			};
			const validatecontray = (rule, value, callback) => { //国家
				if (value === '') {
					callback(new Error(this.$t('bc.bc_15')));
				} else {
					callback();
				}
			};
			const validateresource = (rule, value, callback) => { //保险
				if (value === '') {
					callback(new Error(this.$t('bc.bc_16')));
				} else {
					callback();
				}
			};
			const validatebxid = (rule, value, callback) => { //保险
				if (value === '') {
					callback(new Error(this.$t('bc.bc_17')));
				} else {
					callback();
				}
			};
			const validateway = (rule, value, callback) => { //保险
				if (value === '') {
					callback(new Error(this.$t('bc.bc_18')));
				} else {
					callback();
				}
			};
			const validatezysx = (rule, value, callback) => { //保险
				if (value === '') {
					callback(new Error(this.$t('bc.bc_34')));
				} else {
					callback();
				}
			};
			const validatefh = (rule, value, callback) => {
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				if (value === '') {
					callback(new Error(this.$t('bc.bc_26')));
				} else if (isok) {
					callback(new Error(this.$t('bc.bc_26')));

				} else {
					callback();
				}
			};
			const validateway1 = (rule, value, callback) => {
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				if (value === '') {
					callback(new Error(this.$t('bc.bc_27')));
				} else if (isok) {
					callback(new Error(this.$t('bc.bc_27')));

				} else {
					callback();
				}
			};
			const validatewaymonth = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$t('bc.bc_28')));
				} else if (value > 12 || value < 1) {
					callback(new Error(this.$t('bc.bc_43')));
				} else {
					callback();
				}
			};
			const validatewayyear = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$t('bc.bc_29')));
				} else {
					callback();
				}
			};
			const validatewayname = (rule, value, callback) => {
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				if (value === '') {
					callback(new Error(this.$t('bc.bc_30')));
				} else if (isok) {
					callback(new Error(this.$t('bc.bc_30')));

				} else {
					callback();
				}
			};
			const validatewayx = (rule, value, callback) => {
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				if (value === '') {
					callback(new Error(this.$t('bc.bc_31')));
				} else if (isok) {
					callback(new Error(this.$t('bc.bc_31')));

				} else {
					callback();
				}
			};
			const validatewayemail = (rule, value, callback) => {
				var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
				let isok = reg.test(value);
				console.log(isok)
				if (value === '') {
					callback(new Error(this.$t('bc.bc_32')));
				} else if (!isok) {
					callback(new Error(this.$t('Register.Register_lbl13')));
				} else {
					callback();
				}
			};
			const validatewaytel = (rule, value, callback) => {
				var tels = (/^[0-9]{8,13}$/)
				let isok = tels.test(value)
				if (value === '') {
					callback(new Error(this.$t('bc.bc_1')));
				} else if (!isok) {
					callback(new Error(this.$t('bc.bc_47')));
				} else {
					callback();
				}
			};
			const validatetwofh = (rule, value, callback) => {
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				if (value === '') {
					callback(new Error(this.$t('bc.bc_26')));
				} else if (isok) {
					callback(new Error(this.$t('bc.bc_26')));

				} else {
					callback();
				}
			};
			const validatetwoway1 = (rule, value, callback) => {
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				if (value === '') {
					callback(new Error(this.$t('bc.bc_27')));
				} else if (isok) {
					callback(new Error(this.$t('bc.bc_27')));

				} else {
					callback();
				}
			};
			const validatetwowaymonth = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$t('bc.bc_28')));
				} else if (value > 12 || value < 1) {
					callback(new Error(this.$t('bc.bc_43')));
				} else {
					callback();
				}
			};
			const validatetwowayyear = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$t('bc.bc_29')));
				} else {
					callback();
				}
			};
			const validatetwowayname = (rule, value, callback) => {
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				if (value === '') {
					callback(new Error(this.$t('bc.bc_30')));
				} else if (isok) {
					callback(new Error(this.$t('bc.bc_30')));

				} else {
					callback();
				}
			};
			const validatetwowayx = (rule, value, callback) => {
				var regu = "^[ ]+$";
				var re = new RegExp(regu);
				var isok = re.test(value);
				if (value === '') {
					callback(new Error(this.$t('bc.bc_31')));
				} else if (isok) {
					callback(new Error(this.$t('bc.bc_31')));

				} else {
					callback();
				}
			};
			const validatetwowayemail = (rule, value, callback) => {
				var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
				let isok = reg.test(value);
				console.log(isok)
				if (value === '') {
					callback(new Error(this.$t('bc.bc_32')));
				} else if (!isok) {
					callback(new Error(this.$t('Register.Register_lbl13')));
				} else {
					callback();
				}
			};
			const validatetwowaytel = (rule, value, callback) => {
				var tels = (/^[0-9]{8,13}$/)
				let isok = tels.test(value)
				if (value === '') {
					callback(new Error(this.$t('bc.bc_1')));
				} else if (!isok) {
					callback(new Error(this.$t('bc.bc_47')));
				} else {
					callback();
				}
			};
			return {
				photoshow: false,
				userid: '',
				three: '',
				six: '',
				nine: '',
				ersi: '',
				personnum: '',
				addday: '',
				lang: 0,
				cardTIMELIST: [], //时间列表信息
				cardINFO: [], //车辆信息
				dayflag: '0',

				readeraddday: true,
				showcard: false, //信用卡支付 是否禁用
				showLastcard: false, //前回信用卡支付 是否禁用
				zysxText: false, //驾照三年的文字
				resourcecText: false,
				resourcecMsg: '',
				formDIS: false,

				jpdialog: false,
				gjfialog: false,
				form1: document.getElementById("payment-form"),
				Gjtext: '',
				Reviewing1: '',
				weekday: '',
				currentIndex: 0,
				isOpen: false,
				showVideoModal: false,
				loading: false,
				isMobile: false,
				localVideoUrl: require('@/video/zcv.mp4'), // 修改路径指向其他文件夹

				images: [],
				loading: false,
				page: 1,
				pageSize: 10,

				form: {
					hours: '',
					mins: '',
					value1: '',
					type: '',
					typeid: '',
					typemoney: '',
					typetime: '0',
					checked: false,
					ckaddday: '',
					region: '1',
					pernum: '0',
					name: '',
					secondname: '',
					tel: '',
					email: '',
					suremail: '',
					contray: '',
					contraytext: '',
					resource: '0',
					resourcetext: '',
					bx: '',
					bxid: '0',
					bxmoney: '0',
					way: '2',
					fh: '',
					way1: '',
					waymonth: '',
					wayyear: '',
					wayname: '',
					wayx: '',
					wayemail: '',
					waytel: '',

					twofh: '',
					twoway1: '',
					twowaymonth: '',
					twowayyear: '',
					twowayname: '',
					twowayx: '',
					twowayemail: '',
					twowaytel: '',
					Reviewing: false,
					zysx: '',
					photo1: '',
					photo2: '',
					photo3: '',

					curTime: '',
					timedata: '',
					titleTime: '',
				},
				hourslist: [{
					label: '09'
				}, {
					label: '10'
				}, {
					label: '11'
				}, {
					label: '12'
				}, {
					label: '13'
				}, {
					label: '14'
				}, {
					label: '15'
				}, {
					label: '16'
				}, {
					label: '17'
				}, {
					label: '18'
				}, {
					label: '19'
				}],
				minslist: [{
					label: '00'
				}, {
					label: '30'
				}],
				regionoptions: [{
					label: '1'
				}, {
					label: '2'
				}, {
					label: '3'
				}],
				pernumoptions: [{
					label: '0'
				}, {
					label: '1'
				}, {
					label: '2'
				}, {
					label: '3'
				}],
				rules: {
					// value1: [{ //时间
					// 	trigger: ['blur', 'change'],
					// 	validator: validatevalue1,
					// 	required: true,
					// }],
					hours: [{ //小时
						trigger: ['blur', 'change'],
						validator: validatehours,
						required: true,
					}],
					mins: [{ //分钟
						trigger: ['blur', 'change'],
						validator: validatemins,
						required: true,
					}],
					typeid: [{ //radio时间
						trigger: ['blur', 'change'],
						validator: validatetypeid,
						required: true,
					}],
					// region: [{ //乘车人数
					// 	trigger: ['blur', 'change'],
					// 	validator: validateregion
					// }],
					name: [{ //姓
						trigger: ['blur', 'change'],
						validator: validatename,
						required: true,
					}],
					secondname: [{ //名
						trigger: ['blur', 'change'],
						validator: validatesecondname,
						required: true,
					}],
					tel: [{ //电话号
						trigger: ['blur', 'change'],
						validator: validatetel,
						required: true,
					}],
					email: [{ //邮箱
						trigger: ['blur', 'change'],
						validator: validateemail,
						required: true,
					}],
					suremail: [{ //确认邮箱
						trigger: ['blur', 'change'],
						validator: validatesuremail,
						required: true,
					}],
					contray: [{ //国家
						trigger: ['blur', 'change'],
						validator: validatecontray,
						required: true,
					}],
					resource: [{ //運転免許の種類
						trigger: ['blur', 'change'],
						validator: validateresource,
						required: true,
					}],
					bxid: [{ //保险
						trigger: ['blur', 'change'],
						validator: validatebxid,
						required: true,
					}],
					way: [{ //支付方法
						trigger: ['blur', 'change'],
						validator: validateway,
						required: true,
					}],
					zysx: [{ //注意事项
						trigger: ['blur', 'change'],
						validator: validatezysx,
						required: true,
					}],
					fh: [{ //信用卡卡号
						trigger: ['blur', 'change'],
						validator: validatefh,
						required: true,
					}],
					way1: [{ //
						trigger: ['blur', 'change'],
						validator: validateway1,
						required: true,
					}],
					waymonth: [{ //
						trigger: ['blur', 'change'],
						validator: validatewaymonth,
						required: true,
					}],
					wayyear: [{ //
						trigger: ['blur', 'change'],
						validator: validatewayyear,
						required: true,
					}],
					wayname: [{ //
						trigger: ['blur', 'change'],
						validator: validatewayname,
						required: true,
					}],
					wayx: [{ //
						trigger: ['blur', 'change'],
						validator: validatewayx
					}],
					wayemail: [{ //
						trigger: ['blur', 'change'],
						validator: validatewayemail,
						required: true,
					}],
					waytel: [{ //
						trigger: ['blur', 'change'],
						validator: validatewaytel,
						required: true,
					}],
					twofh: [{ //信用卡卡号
						trigger: ['blur', 'change'],
						validator: validatetwofh,
						required: true,
					}],
					twoway1: [{ //
						trigger: ['blur', 'change'],
						validator: validatetwoway1,
						required: true,
					}],
					twowaymonth: [{ //
						trigger: ['blur', 'change'],
						validator: validatetwowaymonth,
						required: true,
					}],
					twowayyear: [{ //
						trigger: ['blur', 'change'],
						validator: validatetwowayyear,
						required: true,
					}],
					twowayname: [{ //
						trigger: ['blur', 'change'],
						validator: validatetwowayname,
						required: true,
					}],
					twowayx: [{ //
						trigger: ['blur', 'change'],
						validator: validatetwowayx
					}],
					twowayemail: [{ //
						trigger: ['blur', 'change'],
						validator: validatetwowayemail,
						required: true,
					}],
					twowaytel: [{ //
						trigger: ['blur', 'change'],
						validator: validatetwowaytel,
						required: true,
					}],
					Reviewing: [{ //
						trigger: ['blur', 'change'],
						validator: validateReviewing,
						required: true,
					}],

					region: [{

						trigger: ['blur', 'change'],

						required: true,
					}],

					pernum: [{
						trigger: ['blur', 'change'],

						required: true,
					}]
				},
				tableData: [{
					id: this.$t('bx.bx_20'),
					name: this.$t('bx.bx_15'),
					amount1: this.$t('bx.bx_16'),
				}, {
					id: this.$t('bx.bx_14'),
					name: this.$t('bx.bx_17'),
					amount1: this.$t('bx.bx_18'),
				}, ],
				url: '',
				KKDT: [],
				contrylist: [],
				ckadddaylist: [],
				typelist: [],
				carlist: '',
				carname: '',
				daymoney: '',
				difference: '',
				addnum: '',

				daymoneyformater: 0,


				bxlist: [],
				qhlist: [],
				carid: '',
				tid: '',
				linecarid: '',
				bxlist_0: '',
				bxlist_1: '',
				bxlist_2: '',
				timeList: [],
				images: [],
			};
		},
		mounted() {
			this.checkIfMobile();
			window.addEventListener('resize', () => {
				this.checkIfMobile();
				if (this.showVideoModal) {
					this.adjustVideoSize();
				}
			});
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.adjustVideoSize);
			// 确保销毁组件时恢复页面滚动
			document.body.style.overflow = '';
		},
		watch: {

			showVideoModal(val) {
				if (val) {
					this.checkIfMobile();
					this.prepareVideo();
				} else {
					// 恢复页面滚动
					document.body.style.overflow = '';
				}
			}

		},
		computed: {},
		methods: {

			pauseVideo() {
				if (this.$refs.videoPlayer) {
					this.$refs.videoPlayer.pause()
				}
			},
			checkIfMobile() {
				this.isMobile = window.innerWidth <= 768;
			},
			async prepareVideo() {
				this.loading = true;
				try {
					await new Promise((resolve) => {
						this.$refs.videoPlayer.oncanplay = resolve;
						this.$refs.videoPlayer.load();
					});
				} catch (error) {
					console.error('视频加载失败:', error);
				} finally {
					this.loading = false;
				}
			},
			adjustVideoSize() {
				const video = this.$refs.videoPlayer;
				if (!video || !video.videoWidth) return;

				// 使用窗口可视区域尺寸，而不是文档尺寸
				const viewportWidth = window.innerWidth;
				const viewportHeight = window.innerHeight;

				// 计算弹窗最大可用尺寸（80%宽度，减去顶部和底部空间）
				const maxDialogWidth = viewportWidth * 0.8;
				const maxDialogHeight = viewportHeight * 0.9; // 保留10%的空间给顶部和底部

				// 计算视频内容区域最大尺寸（弹窗内边距）
				const maxContentWidth = maxDialogWidth - 40; // 减去内边距
				const maxContentHeight = maxDialogHeight - 100; // 减去标题栏和边距

				// 获取视频原始宽高比
				const videoRatio = video.videoWidth / video.videoHeight;

				// 计算适合的尺寸
				let width = maxContentWidth;
				let height = width / videoRatio;

				// 如果计算的高度超过最大高度，则重新计算
				if (height > maxContentHeight) {
					height = maxContentHeight;
					width = height * videoRatio;
				}

				// 确保最小尺寸
				const minSize = Math.min(viewportWidth, viewportHeight) * 0.3;
				width = Math.max(width, minSize);
				height = Math.max(height, minSize);

				// 应用尺寸
				video.style.width = `${width}px`;
				video.style.height = `${height}px`;

				// 防止页面滚动
				document.body.style.overflow = 'hidden';
			},



			openCarousel() {
				this.isOpen = true;
			},
			closeCarousel() {
				this.isOpen = false;
				// 可以在这里添加关闭后的回调逻辑
				this.$emit('closed');
			},
			nextImage() {
				this.currentIndex = (this.currentIndex + 1) % this.images.length;
			},
			prevImage() {
				this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
			},


			cardChange() {
				if (this.form.way == "3") {
					this.Get_TKA_BY_CARD();
				}
			},

			resourceChange() {

				if (this.form.resource != '' && this.form.zysx != '') {
					if (this.form.resource != "0") //不等于日本驾照 
					{
						if (this.form.zysx == "0") //三年未满 禁用
						{
							this.formDIS = true;
							this.resourcecText = false; //国际驾照文本不显示

							let name = this.KKDT.filter(item => item.INIKEY02 == this.form.resource)[0].INIVALUE;

							let msg = this.$t('ReserveCar.ReserveCar_47').replace('{name}', name);
							this.Gjtext = msg;

							this.gjfialog = true;

							this.jpdialog = false;

						} else { //三年以上

							// let name = this.KKDT.filter(item => item.INIKEY02 == this.form.resource)[0].INIVALUE;

							// let msg = this.$t('ReserveCar.ReserveCar_40').replace('{name}', name);
							// this.resourcecMsg = msg;
							if (this.form.checked.toString() == 'true') {
								this.readeraddday = false;
							} else {
								this.readeraddday = true;
							}
							this.form.way = "2";
							this.form.bxid = '3'
							this.bxlist.filter(item => item.INIKEY02 == '0')[0].INIDIS = true;
							//this.bxlist.filter(item => item.INIKEY02 == '1')[0].INIDIS = true;
							this.bxlist.filter(item => item.INIKEY02 == '2')[0].INIDIS = true;
							this.bxlist.filter(item => item.INIKEY02 == '3')[0].INIDIS = false;
							this.showcard = true; //禁用信用卡支付
							this.showLastcard = true; //禁用信用卡支付
							this.zysxText = false; //三年未满不显示
							this.resourcecText = true; //国际驾照文本显示

							this.jpdialog = false;
							this.gjfialog = false;

							this.form.fh = ''
							this.form.way1 = ''
							this.form.waymonth = ''
							this.form.wayyear = ''
							this.form.wayname = ''
							this.form.wayx = ''
							this.form.wayemail = ''
							this.form.waytel = ''

							this.form.twofh = ''
							this.form.twoway1 = ''
							this.form.twowaymonth = ''
							this.form.twowayyear = ''
							this.form.twowayname = ''
							this.form.twowayx = ''
							this.form.twowayemail = ''
							this.form.twowaytel = ''
							this.form.Reviewing = 'false'
						}

					} else {

						if (this.form.resource == '0' && this.form.zysx == '1') //等于日本驾照 并且三年以上 
						{
							if (this.form.checked.toString() == 'true') {
								this.readeraddday = false;
							} else {
								this.readeraddday = true;
							}

							// this.form.way = '2'
							this.form.bxid = '0'

							this.bxlist.filter(item => item.INIKEY02 == '0')[0].INIDIS = false;
							//this.bxlist.filter(item => item.INIKEY02 == '1')[0].INIDIS = false;
							this.bxlist.filter(item => item.INIKEY02 == '2')[0].INIDIS = false;
							this.bxlist.filter(item => item.INIKEY02 == '3')[0].INIDIS = true;
							this.showcard = false;
							this.showLastcard = false;
							this.zysxText = false;
							this.resourcecText = false;
							this.jpdialog = false;
							this.gjfialog = false;
						} else { //等于日本驾照 并且三年未满 也是现金

							this.formDIS = false;
							this.jpdialog = true;
							this.gjfialog = false;

							// this.form.way = '1'
							// this.form.bxid = '3'
							// this.bxlist.filter(item => item.INIKEY02 == '0')[0].INIDIS = true;
							// this.bxlist.filter(item => item.INIKEY02 == '1')[0].INIDIS = true;
							// this.bxlist.filter(item => item.INIKEY02 == '2')[0].INIDIS = true;
							// this.bxlist.filter(item => item.INIKEY02 == '3')[0].INIDIS = false;
							// this.showcard = true; //禁用信用卡支付
							// this.showLastcard = true; //禁用信用卡支付
							// // this.zysxText = true; //驾照三年文本显示

							// this.resourcecText = false; //国际驾照文本不显示

							// this.form.fh = ''
							// this.form.way1 = ''
							// this.form.waymonth = ''
							// this.form.wayyear = ''
							// this.form.wayname = ''
							// this.form.wayx = ''
							// this.form.wayemail = ''
							// this.form.waytel = ''

							// this.form.twofh = ''
							// this.form.twoway1 = ''
							// this.form.twowaymonth = ''
							// this.form.twowayyear = ''
							// this.form.twowayname = ''
							// this.form.twowayx = ''
							// this.form.twowayemail = ''
							// this.form.twowaytel = ''
						}

					}
				}


			},

			//驾照期限的变更
			zysxChange() {
				// 
				if (this.form.zysx != '') {

					if (this.form.zysx == '0') //三年未满
					{
						this.formDIS = true;

						if (this.form.resource == "0") //日本驾照
						{
							this.jpdialog = true;

						} else {

							this.jpdialog = false;
							this.gjfialog = true;
							let name = this.KKDT.filter(item => item.INIKEY02 == this.form.resource)[0].INIVALUE;

							let msg = this.$t('ReserveCar.ReserveCar_47').replace('{name}', name);
							this.Gjtext = msg;
						}

					} else {

						this.resourceChange();
						this.formDIS = false;
						this.jpdialog = false;
					}

				} else {

					this.formDIS = false;
					this.jpdialog = false;
				}
			},

			// 前回信用卡
			Get_TKA_BY_CARD() {

				console.log(123456);


				this.$api.post(this.$config.Get_TKA_BY_CARD, {
						'sMSTID': sessionStorage.getItem('log_mstid'),
					},
					// 请求成功
					success => {
						this.qhlist = success.KKDT
						this.form.fh = success.KKDT[0].TKACADID
						this.form.way1 = success.KKDT[0].TKACACVV
						this.form.waymonth = success.KKDT[0].TKACAMON
						this.form.wayyear = success.KKDT[0].TKACAYER
						this.form.wayname = success.KKDT[0].TKACAAME
						this.form.wayx = success.KKDT[0].TKACANAM
						this.form.wayemail = success.KKDT[0].TKACAEML
						this.form.waytel = success.KKDT[0].TKACATEL
						console.log(this.qhlist)
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},

			// 获取用户信用卡
			getuser() {
				this.$api.post(this.$config.Get_User, {
						'sMSTID': sessionStorage.getItem('log_mstid') != null ? sessionStorage.getItem('log_mstid') :
							'',
					},
					// 请求成功
					success => {
						console.log(success)
						if (success.KKDT.count > 0) {
							this.form.name = success.KKDT[0].PBAFAMNM
							this.form.secondname = success.KKDT[0].PBAGIVNM
							this.form.tel = success.KKDT[0].PBATELNO
							this.form.email = success.KKDT[0].PBAEMAIL
							this.form.suremail = success.KKDT[0].PBAEMAIL
							this.form.resource = success.KKDT[0].PBACERTI == "" ? '0' : success.KKDT[0].PBACERTI

							this.form.twofh = success.KKDT[0].PBACADID
							this.form.twoway1 = success.KKDT[0].PBACACVV
							this.form.twowaymonth = success.KKDT[0].PBACAMON
							this.form.twowayyear = success.KKDT[0].PBACAYER
							this.form.twowayname = success.KKDT[0].PBACANAM
							this.form.twowayx = success.KKDT[0].PBACAAME
							this.form.twowayemail = success.KKDT[0].PBACAEML
							this.form.twowaytel = success.KKDT[0].PBACATEL
						}
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},

			// 公用获取 radio 下拉框接口
			GET_INI_LIST() {

				// 3/6/9/24/1
				this.$api.post(this.$config.GET_INI_LIST, {
						'sCOMID': '000',
						'sLNGCT': this.lang,
						'sKEY01': '10166'
					},
					// 请求成功
					success => {
						this.timeList = success.KKDT
						// console.log(this.typelist[0].INIKEY02)
						this.Get_MDT_HOUSE_MONEY()
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},
			getinfo() {
				this.$api.post(this.$config.GET_INI_LIST, {
						'sCOMID': '000',
						'sLNGCT': this.lang,
						'sKEY01': '10165'
					},
					// 请求成功
					success => {
						console.log(success)
						this.KKDT = success.KKDT
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
				// 国家
				this.$api.post(this.$config.GET_INI_LIST, {
						'sCOMID': '000',
						'sLNGCT': '0',
						'sKEY01': '10109'
					},
					// 请求成功
					success => {
						this.contrylist = success.KKDT
						if (this.form.contray == '') {
							this.form.contray = success.KKDT.filter(item => item.INIKEY02 == '392')[0]
								.INIKEY02
							this.form.contraytext = success.KKDT.filter(item => item.INIKEY02 == '392')[0]
								.INIVALUE
						}
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
				// 保险
				this.$api.post(this.$config.GET_INI_LIST, {
						'sCOMID': '000',
						'sLNGCT': this.lang,
						'sKEY01': '10167'
					},
					// 请求成功
					success => {

						let newlist = [];
						for (let i = 0; i < success.KKDT.length; i++) {
							let obj = {

								INIKEY02: success.KKDT[i].INIKEY02,
								INIVALUE: success.KKDT[i].INIVALUE,
								INITXT01: success.KKDT[i].INITXT01,
								INIDIS: false
							}

							newlist.push(obj);
						}


						this.bxlist = newlist;
						console.log(this.bxlist)
						this.bxlist_0 = success.KKDT[0]
						this.bxlist_1 = success.KKDT[1]
						this.bxlist_2 = success.KKDT[2]

						if (sessionStorage.getItem("orderForm") != null && typeof(sessionStorage.getItem(
								"orderForm")) !=
							"undefined" && sessionStorage.getItem("orderForm") != "") {


							this.resourceChange();


						}
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},
			Get_MDT_HOUSE_MONEY() {

				// 获取下单页的 3 6 9 24h 加一日 ）车辆名称 车辆ID  车辆图片
				this.$api.post(this.$config.Get_MDT_HOUSE_MONEY, {
						'sMDHID': this.linecarid,
						'sLNGCT': this.lang,
					},
					// 请求成功
					success => {
						if (success.KKDT) {

							this.carlist = success.KKDT[0]
							this.carname = success.KKDT[0].MDHNAME1
							this.carid = success.KKDT[0].MDTMDHID
							this.url = success.KKDT[0].MDQMLINK
							this.daymoney = success.KKDT[0].MDTADDAY
							this.difference = success.KKDT[0].MDTDIFPA
							this.payfor = success.KKDT[0].MDTPAYFO
							this.back11 = success.KKDT[0].MDTBACK1
							this.back22 = success.KKDT[0].MDTBACK2
							//this.daymoneyformater = Number(success.KKDT[0].MDTADDAY).toLocaleString();
							if (this.back11 !== '') {
								this.tableData[0].amount1 = this.back11;
							} else {
								this.tableData[0].amount1 = this.$t('bx.bx_16');
							}
							if (this.back22 !== '') {
								this.tableData[1].amount1 = this.back22;
							} else {
								this.tableData[1].amount1 = this.$t('bx.bx_18');
							}
							let pay1 = this.$t('ReserveCar.ReserveCar_61').replace('{pay}', (Number(this.payfor) ||
								0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'));
							this.Reviewing1 = pay1;

							this.timeList.map((item, index) => {
								// console.log((Number(this.carlist.MDTSHOUR)|| 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'))
								// this.carlist.MDTSHOUR = (Number(this.carlist.MDTSHOUR)|| 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
								if (item.INIVALUE == '3h') {
									item.INIVALUE1 = item.INIVALUE + this.$t('ReserveCar.ReserveCar_55') +
										'￥' + (Number(this.carlist.MDTTHOUR) ||
											0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + ''
									item.INIVmoney = this.carlist.MDTTHOUR
									item.dispshow = this.three
								}
								if (item.INIVALUE == '6h') {
									item.INIVALUE1 = item.INIVALUE + this.$t('ReserveCar.ReserveCar_56') +
										'￥' + (Number(this.carlist.MDTSHOUR) ||
											0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + ''
									// item.INIVALUE1 = item.INIVALUE + '(￥' + this.carlist.MDTSHOUR + ')'
									item.INIVmoney = this.carlist.MDTSHOUR

									item.dispshow = this.six
								}
								if (item.INIVALUE == '9h') {
									item.INIVALUE1 = item.INIVALUE + this.$t('ReserveCar.ReserveCar_57') +
										'￥' + (Number(this.carlist.MDTNHOUR) ||
											0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + ''
									// item.INIVALUE1 = item.INIVALUE + '(￥' + this.carlist.MDTNHOUR + ')'
									item.INIVmoney = this.carlist.MDTNHOUR
									item.dispshow = this.nine
								}
								if (item.INIVALUE == '24h') {
									item.INIVALUE1 = item.INIVALUE + this.$t('ReserveCar.ReserveCar_58') +
										'￥' + (Number(this.carlist.MDTTRHUR) ||
											0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + ''
									// item.INIVALUE1 = item.INIVALUE + '(￥' + this.carlist.MDTTRHUR + ')'
									item.INIVmoney = this.carlist.MDTTRHUR
									item.dispshow = this.ersi
								}
							})
							this.typelist = this.timeList;
							console.log(this.typelist)
						}
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex % 2 === 0) {
						return {
							rowspan: 2,
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},
			Reservesure() {
				this.$refs['ruleForm', 'ruleForm2'].validate((valid) => {
					if (valid) {
						console.log(this.form.contray)
						this.form.resourcetext = this.KKDT.filter(item => item.INIKEY02 == this.form.resource)[0]
							.INIVALUE
						this.form.bx = this.bxlist.filter(item => item.INIKEY02 == this.form.bxid)[0].INIVALUE
						this.form.bxmoney = this.bxlist.filter(item => item.INIKEY02 == this.form.bxid)[0].INITXT01
						if (this.form.typeid) {
							this.form.type = this.typelist.filter(item => item.INIKEY02 == this.form.typeid)[0]
								.INIVALUE1

							this.form.typemoney = this.typelist.filter(item => item.INIKEY02 == this.form.typeid)[
									0]
								.INIVmoney
							this.form.typetime = this.typelist.filter(item => item.INIKEY02 == this.form.typeid)[0]
								.INIVALUE
							this.form.contraytext = this.contrylist.filter(item => item.INIKEY02 == this.form
								.contray)[
								0].INIVALUE
							this.form.ckadddaytext = this.ckadddaylist.filter(item => item.DAY == this.form
								.ckaddday)[
								0].DATE
						}

						this.$router.push({
							name: 'Reservesure',
							query: {
								carid: this.carid,

							} // 要传递的参数
						})

						this.form.value1 = this.form.hours + ':' + this.form.mins
						console.log(this.form.value1)
						let form = {
							hours: this.form.hours,
							mins: this.form.mins,
							url: this.url,
							carname: this.carname,
							linecarid: this.linecarid,
							daymoney: this.daymoney,
							difference: this.difference,
							addnum: this.addnum,
							tid: this.tid,
							three: this.three,
							six: this.six,
							nine: this.nine,
							ersi: this.ersi,
							personnum: this.personnum,
							addday: this.addday,
							ckaddday: this.form.ckaddday,
							ckadddaytext: this.form.ckadddaytext,
							curTime: this.form.curTime,
							timedata: this.form.timedata,
							titleTime: this.form.titleTime,
							value1: this.form.value1,
							type: this.form.type,
							typeid: this.form.typeid,
							typemoney: this.form.typemoney,
							typetime: this.form.typetime,
							checked: this.form.checked,
							region: this.form.region,
							pernum: this.form.pernum,
							name: this.form.name,
							secondname: this.form.secondname,
							tel: this.form.tel,
							email: this.form.email,
							suremail: this.form.suremail,
							contray: this.form.contray,
							contraytext: this.form.contraytext,
							resource: this.form.resource,
							resourcetext: this.form.resourcetext,
							bx: this.form.bx,
							bxid: this.form.bxid,
							bxmoney: this.form.bxmoney,
							way: this.form.way,
							fh: this.form.fh,
							way1: this.form.way1,
							waymonth: this.form.waymonth,
							wayyear: this.form.wayyear,
							wayname: this.form.wayname,
							wayx: this.form.wayx,
							wayemail: this.form.wayemail,
							waytel: this.form.waytel,
							twofh: this.form.twofh,
							twoway1: this.form.twoway1,
							twowaymonth: this.form.twowaymonth,
							twowayyear: this.form.twowayyear,
							twowayname: this.form.twowayname,
							twowayx: this.form.twowayx,
							twowayemail: this.form.twowayemail,
							twowaytel: this.form.twowaytel,
							zysx: this.form.zysx,
							hourlist: this.hourslist,
							minslist: this.minslist,
							ckadddaylist: this.ckadddaylist,
							photo1: this.form.photo1,
							photo2: this.form.photo2,
							photo3: this.form.photo3,
						}
						sessionStorage.setItem("orderForm", JSON.stringify(form));

					} else {
						this.$message({
							message: this.$t('bc.bc_38'), //请求失败
							type: 'error'
						});
					}
				})
			},

			Get_Car_BYID() {
				this.$api.post(this.$config.Get_CAR_TIME, {
						'sMDHID': this.linecarid,
						'sLNGCT': this.lang,
						'sDate': this.form.curTime,
						'sWeekday': this.weekday,
					},
					// 请求成功
					success => {
						console.log(success)
						this.cardINFO = success.KKDT0;
						this.cardTIMELIST = success.KKDT1;
						this.addDAYLIST = success.KKDT2;
						this.addDAYLIST1 = success.KKDT3;
						this.images = success.KKDT4;
						console.log(this.cardTIMELIST)
						if (this.three == "false" && this.six == "false" && this.nine == "false" && this.ersi ==
							"false") {
							this.hourslist = [];
							this.minslist = [];
						} else {

							this.setTIME(this.form.typeid);

						}
						if (this.form.ckaddday == '') {
							if (this.form.typeid == "3") {
								this.ckadddaylist = success.KKDT3;
								this.form.ckaddday = success.KKDT3.filter(item => item.DATE == '')[0]
									.DATE;
								this.form.ckadddaytext = success.KKDT3.filter(item => item.DAY == '')[0]
									.DAY;
								if (this.ckadddaylist.length == 1) {
									this.addday = '';
								}
							} else {
								this.ckadddaylist = success.KKDT2;
								this.form.ckaddday = success.KKDT2.filter(item => item.DATE == '')[0]
									.DATE;
								this.form.ckadddaytext = success.KKDT2.filter(item => item.DAY == '')[0]
									.DAY;
								if (this.ckadddaylist.length==1){
									this.addday='';
									}
							}
						} else {
							if (this.form.typeid == "3") {
								this.ckadddaylist = success.KKDT3;
							} else {
								this.ckadddaylist = success.KKDT2;
							}
							if (this.ckadddaylist.length == 1) {
								this.addday = '';
							}

						}
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},

			// 36924 变更切换
			getTIME() {
				let type = this.form.typeid;
				console.log(123);

				if (type == "0") {
					this.getadday();
					let threelist = this.cardTIMELIST;
					console.log(this.addday)
					console.log(this.form.checked)
					if (this.form.checked.toString() == "true") //如果用户勾选了 加一日的切换套餐
					{
						let hour = threelist[0].addday;
						if (hour != "-1") //不等于禁用
						{
							if (hour == "") //代表所有日期都行
							{
								this.setTIME("0");
								this.form.hours = ''
								this.form.mins = ''
							} else { //只有一些日期能行
						
								let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
								// var a1 = str.replace(reg1,""); 作者：朵宝特工007 https://www.bilibili.com/read/cv17421049 出处：bilibili
								console.log(threelist[0].addday.replace(reg1, ""))
								let datahour = threelist[0].addday.replace(reg1, "").toString().substring(0, threelist[0]
									.addday.replace(reg1, "").length - 1);
						
								let xsobj = {};
								let NewHourList = [];
								for (let i = 0; i < datahour.toString().split(',').length; i++) {
									xsobj = {
										label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] :
											datahour.split(',')[i]
									}
									NewHourList.push(xsobj);
								}
						
								this.hourslist = NewHourList;
						
								let stim = threelist[0].stim;
								console.log(stim);
						
								let fzlist = [];
								if (stim == '2') {
									fzlist = [{
											label: '00'
										},
										{
											label: '30'
										}
									]
								} else if (stim == '1') {
									fzlist = [{
										label: '30'
									}]
								} else if (stim == '0') {
									fzlist = [{
										label: '00'
									}]
								}
						
								this.minslist = fzlist;
						
							}
						}
						//等于禁用
						else {

						this.form.checked = false;
						this.addday = '';
						this.readeraddday = true;
						//this.setTIME("0");
						this.form.hours = ''
						this.form.mins = ''
						// this.hourslist=[];
						// this.minslist=[];
						}

						console.log(hour);
					} else {

						this.setTIME("0");
						this.form.hours = ''
						this.form.mins = ''
						this.form.checked = false;
						this.readeraddday = true;

					}
				} else if (type == "1") {
					this.getadday();
					let threelist = this.cardTIMELIST;
					console.log(this.addday)
					console.log(this.form.checked)
					if (this.form.checked.toString() == "true") //如果用户勾选了 加一日的切换套餐
					{
						let hour = threelist[1].addday;
						if (hour != "-1") //不等于禁用
						{
							if (hour == "") //代表所有日期都行
							{
								this.setTIME("1");
								this.form.hours = ''
								this.form.mins = ''
							} else { //只有一些日期能行
						
								let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
								// var a1 = str.replace(reg1,""); 作者：朵宝特工007 https://www.bilibili.com/read/cv17421049 出处：bilibili
								console.log(threelist[1].addday.replace(reg1, ""))
								let datahour = threelist[1].addday.replace(reg1, "").toString().substring(0, threelist[1]
									.addday.replace(reg1, "").length - 1);
						
								let xsobj = {};
								let NewHourList = [];
								for (let i = 0; i < datahour.toString().split(',').length; i++) {
									xsobj = {
										label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] :
											datahour.split(',')[i]
									}
									NewHourList.push(xsobj);
								}
						
								this.hourslist = NewHourList;
						
								let stim = threelist[1].stim;
								console.log(stim);
						
								let fzlist = [];
								if (stim == '2') {
									fzlist = [{
											label: '00'
										},
										{
											label: '30'
										}
									]
								} else if (stim == '1') {
									fzlist = [{
										label: '30'
									}]
								} else if (stim == '0') {
									fzlist = [{
										label: '00'
									}]
								}
						
								this.minslist = fzlist;
						
							}
						}
						//等于禁用
						else {

						this.form.checked = false;
						this.addday = '';
						this.readeraddday = true;
						//this.setTIME("1");
						this.form.hours = ''
						this.form.mins = ''
						// this.hourslist=[];
						// this.minslist=[];
						}

						console.log(hour);
					} else {

						this.setTIME("1");
						this.form.hours = ''
						this.form.mins = ''
						this.form.checked = false;
						this.readeraddday = true;

					}
				} else if (type == "2") {
					this.getadday();
					let threelist = this.cardTIMELIST;
					console.log(this.addday)
					console.log(this.form.checked)
					if (this.form.checked.toString() == "true") //如果用户勾选了 加一日的切换套餐
					{
						let hour = this.cardTIMELIST[2].addday;
						if (hour != "-1") //不等于禁用
						{
							if (hour == "") //代表所有日期都行
							{
								this.setTIME("2");
								this.form.hours = ''
								this.form.mins = ''
							} else { //只有一些日期能行
						
								let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
								// var a1 = str.replace(reg1,""); 作者：朵宝特工007 https://www.bilibili.com/read/cv17421049 出处：bilibili
								console.log(threelist[2].addday.replace(reg1, ""))
								let datahour = threelist[2].addday.replace(reg1, "").toString().substring(0, threelist[2]
									.addday.replace(reg1, "").length - 1);
						
								let xsobj = {};
								let NewHourList = [];
								for (let i = 0; i < datahour.toString().split(',').length; i++) {
									xsobj = {
										label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] :
											datahour.split(',')[i]
									}
									NewHourList.push(xsobj);
								}
						
								this.hourslist = NewHourList;
						
								let stim = threelist[2].stim;
								console.log(stim);
						
								let fzlist = [];
								if (stim == '2') {
									fzlist = [{
											label: '00'
										},
										{
											label: '30'
										}
									]
								} else if (stim == '1') {
									fzlist = [{
										label: '30'
									}]
								} else if (stim == '0') {
									fzlist = [{
										label: '00'
									}]
								}
						
								this.minslist = fzlist;
						
							}
						}
						//等于禁用
						else {

						this.form.checked = false;
						this.addday = '';
						this.readeraddday = true;
						//this.setTIME("2");
						this.form.hours = ''
						this.form.mins = ''
						// this.hourslist=[];
						// this.minslist=[];
							}

						console.log(hour);
					} else {

						this.setTIME("2");
						this.form.hours = ''
						this.form.mins = ''
						this.form.checked = false;
						this.readeraddday = true;

					}
				} else if (type == "3") {
						this.form.checked = true;
						this.readeraddday = false;
					this.getadday();
					let threelist = this.cardTIMELIST;
					console.log(this.addday)
					console.log(this.form.checked)

					if (this.ckadddaylist.length == 1) {
						this.addday = '';
						this.form.checked = false;
					}
					if (this.form.checked.toString() == "true") //如果用户勾选了 加一日的切换套餐
					{
						let hour = this.cardTIMELIST[3].addday;
						if (hour != "-1") //不等于禁用
						{
							if (hour == "") //代表所有日期都行
							{
								this.setTIME("3");
								this.form.hours = ''
								this.form.mins = ''
							} else { //只有一些日期能行

								let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
								// var a1 = str.replace(reg1,""); 作者：朵宝特工007 https://www.bilibili.com/read/cv17421049 出处：bilibili
								console.log(threelist[3].addday.replace(reg1, ""))
								let datahour = threelist[3].addday.replace(reg1, "").toString().substring(0, threelist[3]
									.addday.replace(reg1, "").length - 1);

								let xsobj = {};
								let NewHourList = [];
								for (let i = 0; i < datahour.toString().split(',').length; i++) {
									xsobj = {
										label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] :
											datahour.split(',')[i]
									}
									NewHourList.push(xsobj);
								}

								this.hourslist = NewHourList;

								let stim = threelist[3].stim;
								console.log(stim);

								let fzlist = [];
								if (stim == '2') {
									fzlist = [{
											label: '00'
										},
										{
											label: '30'
										}
									]
								} else if (stim == '1') {
									fzlist = [{
										label: '30'
									}]
								} else if (stim == '0') {
									fzlist = [{
										label: '00'
									}]
								}

								this.minslist = fzlist;

							}
						}
						//等于禁用
						else {

							this.form.checked = false;
							this.setTIME("3");
							this.form.hours = ''
							this.form.mins = ''
							// this.hourslist=[];
							// this.minslist=[];
						}

						console.log(hour);
					} else {

						this.form.checked = false;
						this.setTIME("3");
						this.form.hours = ''
						this.form.mins = ''

					}
				}

			},

			//时间赋值(只是默认值 不包含选择加一日之后的可选日期)
			setTIME(type) {
				let hour = this.cardTIMELIST;
				if (type == '0') {
					let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
					console.log(hour[0].hour.replace(reg1, ""))
					let datahour = hour[0].hour.replace(reg1, "").toString().substring(0, hour[0].hour.replace(reg1, "")
						.length - 1);
					console.log(datahour)
					let xsobj = {};
					let NewHourList = [];
					for (let i = 0; i < datahour.toString().split(',').length; i++) {
						console.log(datahour.split(',')[i])
						xsobj = {
							label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] : datahour.split(
								',')[i]
						}
						NewHourList.push(xsobj);
					}
					console.log(NewHourList);

					this.hourslist = NewHourList;
					this.form.hours = NewHourList[0].label;

					let stim = hour[0].stim;
					console.log(stim);

					let fzlist = [];
					if (stim == '2') {
						fzlist = [{
								label: '00'
							},
							{
								label: '30'
							}
						]
					} else if (stim == '1') {
						fzlist = [{
							label: '30'
						}]
					} else if (stim == '0') {
						fzlist = [{
							label: '00'
						}]
					}

					this.minslist = fzlist;
					this.form.mins = fzlist[0].label;
					console.log(this.addday)
					if (this.addday == 'true') //如果传过来的没禁用 那就看对应的 36924套餐禁用了么
					{
						let day = hour[0].addday;
						console.log(day)
						if (day != "-1") {
							this.addday = 'true';
						} else {

							this.addday = 'false';
						}

					} else {
						let kkdt0 = this.cardINFO;
						if (kkdt0[0].addday == 'false') {
							this.addday = "false"
						} else {
							if (this.dayflag == "1" && this.addday == 'false') {
								this.addday = 'false';
							} else {


								let day = hour[0].addday;
								console.log(day)
								if (day != "-1") {
									this.addday = 'true';
								} else {

									this.addday = 'false';
								}
							}

						}
					}
				} else if (type == '1') {
					let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
					console.log(hour[1].hour.replace(reg1, ""))
					let datahour = hour[1].hour.replace(reg1, "").toString().substring(0, hour[1].hour.replace(reg1, "")
						.length - 1);
					console.log(datahour)
					let xsobj = {};
					let NewHourList = [];
					for (let i = 0; i < datahour.toString().split(',').length; i++) {
						console.log(datahour.split(',')[i])
						xsobj = {
							label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] : datahour.split(
								',')[i]
						}
						NewHourList.push(xsobj);
					}
					console.log(NewHourList);

					this.hourslist = NewHourList;
					this.form.hours = NewHourList[0].label;

					let stim = hour[1].stim;
					console.log(stim);

					let fzlist = [];
					if (stim == '2') {
						fzlist = [{
								label: '00'
							},
							{
								label: '30'
							}
						]
					} else if (stim == '1') {
						fzlist = [{
							label: '30'
						}]
					} else if (stim == '0') {
						fzlist = [{
							label: '00'
						}]
					}

					this.minslist = fzlist;
					this.form.mins = fzlist[0].label;
					console.log(this.addday)
					if (this.addday == 'true' || this.addday == "") //如果传过来的没禁用 那就看对应的 36924套餐禁用了么
					{
						let day = hour[1].addday;
						console.log(day)
						if (day != "-1") {
							this.addday = 'true';
						} else {

							this.addday = 'false';
						}

					} else {
						let kkdt0 = this.cardINFO;
						if (kkdt0[0].addday == 'false') {
							this.addday = "false"
						} else {

							if (this.dayflag == "1" && this.addday == 'false') {
								this.addday = 'false';
							} else {


								let day = hour[1].addday;
								console.log(day)
								if (day != "-1") {
									this.addday = 'true';
								} else {

									this.addday = 'false';
								}
							}
						}
					}
				} else if (type == '2') {
					let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
					console.log(hour[2].hour.replace(reg1, ""))
					let datahour = hour[2].hour.replace(reg1, "").toString().substring(0, hour[2].hour.replace(reg1, "")
						.length - 1);
					console.log(datahour)
					let xsobj = {};
					let NewHourList = [];
					for (let i = 0; i < datahour.toString().split(',').length; i++) {
						console.log(datahour.split(',')[i])
						xsobj = {
							label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] : datahour.split(
								',')[i]
						}
						NewHourList.push(xsobj);
					}
					console.log(NewHourList);

					this.hourslist = NewHourList;
					this.form.hours = NewHourList[0].label;

					let stim = hour[2].stim;
					console.log(stim);

					let fzlist = [];
					if (stim == '2') {
						fzlist = [{
								label: '00'
							},
							{
								label: '30'
							}
						]
					} else if (stim == '1') {
						fzlist = [{
							label: '30'
						}]
					} else if (stim == '0') {
						fzlist = [{
							label: '00'
						}]
					}

					this.minslist = fzlist;
					this.form.mins = fzlist[0].label;
					console.log(this.addday)
					if (this.addday == 'true' || this.addday == "") //如果传过来的没禁用 那就看对应的 36924套餐禁用了么
					{
						let day = hour[2].addday;
						console.log(day)
						if (day != "-1") {
							this.addday = 'true';
						} else {

							this.addday = 'false';
						}

					} else {
						let kkdt0 = this.cardINFO;
						if (kkdt0[0].addday == 'false') {
							this.addday = "false"
						} else {

							if (this.dayflag == "1" && this.addday == 'false') {
								this.addday = 'false';
							} else {


								let day = hour[2].addday;
								console.log(day)
								if (day != "-1") {
									this.addday = 'true';
								} else {

									this.addday = 'false';
								}
							}
						}
					}
				} else if (type == '3') {
					let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
					console.log(hour[3].hour.replace(reg1, ""))
					let datahour = hour[3].hour.replace(reg1, "").toString().substring(0, hour[3].hour.replace(reg1, "")
						.length - 1);
					console.log(datahour)
					let xsobj = {};
					let NewHourList = [];
					for (let i = 0; i < datahour.toString().split(',').length; i++) {
						console.log(datahour.split(',')[i])
						xsobj = {
							label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] : datahour.split(
								',')[i]
						}
						NewHourList.push(xsobj);
					}
					console.log(NewHourList);

					this.hourslist = NewHourList;
					this.form.hours = NewHourList[0].label;

					let stim = hour[3].stim;
					console.log(stim);

					let fzlist = [];
					if (stim == '2') {
						fzlist = [{
								label: '00'
							},
							{
								label: '30'
							}
						]
					} else if (stim == '1') {
						fzlist = [{
							label: '30'
						}]
					} else if (stim == '0') {
						fzlist = [{
							label: '00'
						}]
					}

					this.minslist = fzlist;
					this.form.mins = fzlist[0].label;
					console.log(this.addday)
					if (this.addday == 'true' || this.addday == "") //如果传过来的没禁用 那就看对应的 36924套餐禁用了么
					{
						let day = hour[3].addday;
						console.log(day)
						if (day != "-1") {
							this.addday = 'true';
						} else {

							this.addday = 'false';
						}

					} else {
						let kkdt0 = this.cardINFO;
						if (kkdt0[0].addday == 'false') {
							this.addday = "false"
						} else {

							if (this.dayflag == "1" && this.addday == 'false') {
								this.addday = 'false';
							} else {


								let day = hour[3].addday;
								console.log(day)
								if (day != "-1") {
									this.addday = 'true';
								} else {

									this.addday = 'false';
								}
							}
						}
					}
				}

				if (this.ckadddaylist.length == 1) {
					this.addday = '';
					this.form.checked = false;
					this.readeraddday = true;
				}
			},

			//追加一日变更
			adddayChange() {
				if (this.form.checked.toString() == 'true') {
					this.ckadddayChange();
					this.readeraddday = false;

					if (this.form.typeid == '0') //3h
					{
						let threelist = this.cardTIMELIST;
						let hour = threelist[0].addday;
						this.form.hours = ''
						this.form.mins = ''
						if (hour == "") {
							this.setTIME(0);
							this.form.hours = ''
							this.form.mins = ''
						} else {
							let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
							// var a1 = str.replace(reg1,""); 作者：朵宝特工007 https://www.bilibili.com/read/cv17421049 出处：bilibili
							console.log(threelist[0].addday.replace(reg1, ""))
							let datahour = threelist[0].addday.replace(reg1, "").toString().substring(0, threelist[0]
								.addday.replace(reg1, "").length - 1);

							let xsobj = {};
							let NewHourList = [];
							for (let i = 0; i < datahour.toString().split(',').length; i++) {
								xsobj = {
									label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] : datahour
										.split(',')[i]
								}
								NewHourList.push(xsobj);
							}

							this.hourslist = NewHourList;

							let astm = threelist[0].astm;
							console.log(astm);

							let fzlist = [];
							if (astm == '2') {
								fzlist = [{
										label: '00'
									},
									{
										label: '30'
									}
								]
							} else if (astm == '1') {
								fzlist = [{
									label: '30'
								}]
							} else if (astm == '0') {
								fzlist = [{
									label: '00'
								}]
							}

							this.minslist = fzlist;

						}

					} else if (this.form.typeid == '1') //6h
					{
						let threelist = this.cardTIMELIST;
						let hour = threelist[1].addday;
						this.form.hours = ''
						this.form.mins = ''
						if (hour == "") {
							this.setTIME(1);
							this.form.hours = ''
							this.form.mins = ''
						} else {
							let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
							// var a1 = str.replace(reg1,""); 作者：朵宝特工007 https://www.bilibili.com/read/cv17421049 出处：bilibili
							console.log(threelist[1].addday.replace(reg1, ""))
							let datahour = threelist[1].addday.replace(reg1, "").toString().substring(0, threelist[1]
								.addday.replace(reg1, "").length - 1);

							let xsobj = {};
							let NewHourList = [];
							for (let i = 0; i < datahour.toString().split(',').length; i++) {
								xsobj = {
									label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] : datahour
										.split(',')[i]
								}
								NewHourList.push(xsobj);
							}

							this.hourslist = NewHourList;

							let astm = threelist[1].astm;
							console.log(astm);

							let fzlist = [];
							if (astm == '2') {
								fzlist = [{
										label: '00'
									},
									{
										label: '30'
									}
								]
							} else if (astm == '1') {
								fzlist = [{
									label: '30'
								}]
							} else if (astm == '0') {
								fzlist = [{
									label: '00'
								}]
							}

							this.minslist = fzlist;

						}
					} else if (this.form.typeid == '2') //9h
					{

						let threelist = this.cardTIMELIST;
						let hour = threelist[2].addday;
						this.form.hours = ''
						this.form.mins = ''
						if (hour == "") {
							this.setTIME(2);
							this.form.hours = ''
							this.form.mins = ''
						} else {
							let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
							// var a1 = str.replace(reg1,""); 作者：朵宝特工007 https://www.bilibili.com/read/cv17421049 出处：bilibili
							console.log(threelist[2].addday.replace(reg1, ""))
							let datahour = threelist[2].addday.replace(reg1, "").toString().substring(0, threelist[2]
								.addday.replace(reg1, "").length - 1);

							let xsobj = {};
							let NewHourList = [];
							for (let i = 0; i < datahour.toString().split(',').length; i++) {
								xsobj = {
									label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] : datahour
										.split(',')[i]
								}
								NewHourList.push(xsobj);
							}

							this.hourslist = NewHourList;

							let astm = threelist[2].astm;
							console.log(astm);

							let fzlist = [];
							if (astm == '2') {
								fzlist = [{
										label: '00'
									},
									{
										label: '30'
									}
								]
							} else if (astm == '1') {
								fzlist = [{
									label: '30'
								}]
							} else if (astm == '0') {
								fzlist = [{
									label: '00'
								}]
							}

							this.minslist = fzlist;

						}

					} else if (this.form.typeid == '3') //24h
					{
						this.form.hours = ''
						this.form.mins = ''
						let threelist = this.cardTIMELIST;
						let hour = threelist[3].addday;
						if (hour == "") {
							this.setTIME(3);
							this.form.hours = ''
							this.form.mins = ''
						} else {
							let reg1 = new RegExp("'", "g"); // 加'g'，删除字符串里所有的"'"
							// var a1 = str.replace(reg1,""); 作者：朵宝特工007 https://www.bilibili.com/read/cv17421049 出处：bilibili
							console.log(threelist[3].addday.replace(reg1, ""))
							let datahour = threelist[3].addday.replace(reg1, "").toString().substring(0, threelist[3]
								.addday.replace(reg1, "").length - 1);

							let xsobj = {};
							let NewHourList = [];
							for (let i = 0; i < datahour.toString().split(',').length; i++) {
								xsobj = {
									label: datahour.split(',')[i].length < 2 ? "0" + datahour.split(',')[i] : datahour
										.split(',')[i]
								}
								NewHourList.push(xsobj);
							}

							this.hourslist = NewHourList;

							let astm = threelist[3].astm;
							console.log(astm);

							let fzlist = [];
							if (astm == '2') {
								fzlist = [{
										label: '00'
									},
									{
										label: '30'
									}
								]
							} else if (astm == '1') {
								fzlist = [{
									label: '30'
								}]
							} else if (astm == '0') {
								fzlist = [{
									label: '00'
								}]
							}

							this.minslist = fzlist;

						}
					}
				} else {
					this.ckadddayChange();
					this.readeraddday = true;
					this.form.ckaddday = '';
					this.daymoneyformater = 0;
					this.form.hours = ''
					this.form.mins = ''
					if (this.form.typeid == '0') {
						this.setTIME("0")
					} else if (this.form.typeid == '1') {
						this.setTIME("1")
					} else if (this.form.typeid == '2') {
						this.setTIME("2")
					} else if (this.form.typeid == '3') {
						this.setTIME("3")
					}
				}
			},

			ckadddayChange() {
				let strday = 0;
				let stdifference = 0;
				this.addnum = 0;
				if (this.form.checked.toString() == 'true') {
					strday = this.form.ckaddday.split(" ")[0];
					this.addnum = strday;
					if (strday>0 && this.form.typeid != '3'){
					stdifference=this.difference;
					}
				}
				let strmoney = this.daymoney;
				this.daymoneyformater = ((Number(strmoney) * Number(strday)) + Number(stdifference)).toLocaleString();
			},
			//小时文本框变更事件
			hourChange() {
				if (this.form.hours != "") {

					let starindex = 0;
					let endindex = this.hourslist.length - 1;
					let findindex = this.hourslist.findIndex(item => item.label == this.form.hours);
					console.log(findindex);
					if (findindex == starindex) {

						let type = this.cardTIMELIST.filter(item => item.TKAHOURS == this.form.typeid);



						let stim = "";
						// if (this.form.checked.toString() == "true") {
						// 	stim = type[0].atim;
						// } else {
						// }
						stim = type[0].stim;

						if (stim == "2") {
							this.minslist = [{
									label: '00'
								},
								{
									label: '30'
								},
							]
						} else if (stim == "1") {
							this.minslist = [{
								label: '30'
							}, ]
							this.form.mins = this.minslist[0].label;
						} else if (stim == "0") {
							this.minslist = [{
								label: '00'
							}, ]
							this.form.mins = this.minslist[0].label;
						} else {

							this.minslist = [{
								label: '00'
							}, ]

							this.form.mins = this.minslist[0].label;
						}


					} else if (findindex == endindex) {
						console.log(this.form.typeid)
						console.log(this.cardTIMELIST.filter(item => item.TKAHOURS == this.form.typeid)[0].stim)
						let type = this.cardTIMELIST.filter(item => item.TKAHOURS == "0");
						let etim = type[0].etim;
						// if (this.form.checked.toString() == "true") {
						// 	etim = type[0].aetm;
						// } 

						if (etim == "2") {
							this.minslist = [{
									label: '00'
								},
								{
									label: '30'
								},
							]

						} else if (etim == "1") {

							this.minslist = [{
								label: '30'
							}, ]

							this.form.mins = this.minslist[0].label;
						} else if (etim == "0") {

							this.minslist = [{
								label: '00'
							}, ]

							this.form.mins = this.minslist[0].label;
						} else {

							this.minslist = [{
								label: '00'
							}, ]

							this.form.mins = this.minslist[0].label;
						}
					} else { //中间的时间段部位 都有
						this.minslist = [{
								label: '00'
							},
							{
								label: '30'
							},
						]
					}
				}

			},
			//国家变更事件
			COYIDChange() {
				if (this.form.contray != "392") {
					this.form.resource = "3";
					this.form.bxid = '3';
					this.resourceChange();
				}

			},
			photolist() {

				this.photoshow = !this.photoshow
			},



			getadday() {
				if (this.form.typeid == "3") {
					this.ckadddaylist = this.addDAYLIST1;
					this.form.ckaddday = this.addDAYLIST1.filter(item => item.DATE == '')[0]
						.DATE;
					this.form.ckadddaytext = this.addDAYLIST1.filter(item => item.DAY == '')[0]
						.DAY;
				} else {
					this.ckadddaylist = this.addDAYLIST;
					this.form.ckaddday = this.addDAYLIST.filter(item => item.DAY == '')[0]
						.DATE;
					this.form.ckadddaytext = this.addDAYLIST.filter(item => item.DAY == '')[0]
						.DATE;
				}
				this.ckadddayChange();
			},

		},



		created() {
			console.log(this.$route.query)
			this.weekday = this.$route.query.weekday;
			if (this.$i18n.locale == 'ja') {
				this.lang = 0
			}
			if (this.$i18n.locale == 'zh') {
				this.lang = 1
			}
			if (this.$i18n.locale == 'en') {
				this.lang = 2
			}

			// this.GET_INI_LIST()

			if (sessionStorage.getItem("orderForm") != null && typeof(sessionStorage.getItem("orderForm")) !=
				"undefined" && sessionStorage.getItem("orderForm") != "") {
				let form = JSON.parse(sessionStorage.getItem("orderForm"))
				console.log("jinlaile ")
				this.three = form.three
				this.six = form.six
				this.nine = form.nine
				this.ersi = form.ersi
				this.personnum = form.personnum
				this.addday = form.addday
				this.url = form.url
				this.carname = form.carname
				this.daymoney = form.daymoney
				this.addnum = form.addnum
				this.difference =  form.difference
				if(Number(this.addnum) > 0 && this.form.typeid != '3'){
				this.daymoneyformater = ((Number(form.daymoney) * Number(form.addnum)) + Number(form.difference)).toLocaleString();
				}else{
				this.daymoneyformater = (Number(form.daymoney) * Number(form.addnum)).toLocaleString();
				}
				this.form.hours = form.hours
				this.form.mins = form.mins
				this.form.curTime = this.$route.query.curTime;
				this.form.timedata = form.timedata;
				// this.form.titleTime = form.titleTime;
				this.form.checked = form.checked
				this.form.ckaddday = form.ckaddday
				this.form.ckadddaytext = form.ckadddaytext
				this.form.region = form.region
				this.form.pernum = form.pernum
				this.form.name = form.name
				this.form.secondname = form.secondname
				this.form.tel = form.tel
				this.form.email = form.email
				this.form.suremail = form.suremail
				this.form.contray = form.contray
				this.form.contraytext = form.contrayvalue
				this.form.resource = form.resource
				this.form.resourcetext = form.resourcetext
				this.form.bx = form.bx
				this.form.bxid = form.bxid
				this.form.bxmoney = form.bxmoney
				this.form.way = form.way

				this.hourslist = form.hourlist
				this.minslist = form.minslist
				this.ckadddaylist = form.ckadddaylist
				this.form.fh = form.fh
				this.form.way1 = form.way1
				this.form.waymonth = form.waymonth
				this.form.wayyear = form.wayyear
				this.form.wayname = form.wayname
				this.form.wayx = form.wayx
				this.form.wayemail = form.wayemail
				this.form.waytel = form.waytel
				this.form.photo1 = form.photo1
				this.form.photo2 = form.photo2
				this.form.photo3 = form.photo3

				console.log(this.form.fh)

				if (this.form.fh != '') {
					let obj = {
						fh: form.fh,
						way1: form.way1,
						waymonth: form.waymonth,
						wayyear: form.wayyear,
						wayname: form.wayname,
						wayx: form.wayx,
						wayemail: form.wayemail,
						waytel: form.waytel,
					}

					this.qhlist.push(obj);
				}



				this.form.twofh = form.twofh
				this.form.twoway1 = form.twoway1
				this.form.twowaymonth = form.twowaymonth
				this.form.twowayyear = form.twowayyear
				this.form.twowayname = form.twowayname
				this.form.twowayx = form.twowayx
				this.form.twowayemail = form.twowayemail
				this.form.twowaytel = form.twowaytel


				this.form.zysx = form.zysx
				this.form.type = form.type
				this.form.typeid = form.typeid
				this.form.typemoney = form.typemoney
				this.form.typetime = form.typetime
				this.form.Reviewing = form.Reviewing


				// console.log(this.form.type)
				this.tid = form.tid
				// this.carid = this.$route.query.carid
				this.linecarid = this.$route.query.linecarid
				this.form.value1 = form.value1
				this.GET_INI_LIST()


			} else {
				let carform = JSON.parse(sessionStorage.getItem("carform"))
				console.log(carform)

				// return;
				this.form.curTime = this.$route.query.curTime;
				this.linecarid = this.$route.query.linecarid
				// this.form.timedata = this.$route.query.timedata;
				// this.form.titleTime = this.$route.query.titleTime;

				this.three = carform.three
				this.six = carform.six
				this.nine = carform.nine
				this.ersi = carform.ersi
				this.personnum = carform.personnum
				this.addday = carform.addday
				this.dayflag = carform.dayflag
				console.log(carform.types);
				console.log(this.addday);

				if (typeof(carform.types) != "undefined" && carform.types.toString().length > 0) {
					console.log(111)
					this.form.typeid = carform.types.toString()
				} else {

					if (this.three == "true") {
						this.form.typeid = '0';
					} else if (this.six == "true") {
						this.form.typeid = '1';
					} else if (this.nine == "true") {
						this.form.typeid = '2';
					} else if (this.ersi == "true") {
						this.form.typeid = '3';
					}
				}




				// 格式化年月日
				var timerq = /^(\d{4})-(\d{1,2})-(\d{1,2})$/
				var datar = this.form.curTime.match(timerq)
				if (this.lang == 2) {
					this.form.timedata = datar[1] + '-' + datar[2] + '-' + datar[3]
				} else {
					this.form.timedata = datar[1] + '年' + datar[2] + '月' + datar[3] + '日'
				}
				this.GET_INI_LIST()

				this.getuser()
				this.Get_Car_BYID();

			}



			this.getinfo()
			this.userid = sessionStorage.getItem('log_mstid')
			if (sessionStorage.getItem('log_mstid')) {

				// if (sessionStorage.getItem('log_mstid')) {
				// 	this.Get_TKA_BY_CARD()
				// }
				console.log(sessionStorage.getItem("orderForm") == '');

				console.log(sessionStorage.getItem("orderForm") == null);
				if (sessionStorage.getItem('log_mstid') && (sessionStorage.getItem("orderForm") == '' || sessionStorage
						.getItem("orderForm") == null)) {
					this.Get_TKA_BY_CARD()
				}

			}
		},

	}
</script>


<style scoped>
	@media only screen and (min-width:680px) {
		.bxrow {
			display: flex;
			flex-direction: row;
		}

		/deep/.el-image {
			width: 160px;
			height: 96px
		}

		.surebg {
			width: 80%;
			margin: 0 auto;
		}

		.reservebg {
			width: 80%;
			margin: 0 auto;
			margin-top: 30px
		}

		.reservetop>p {
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
			margin-top: 70px
		}

		.carlinbn {
			margin: 60px auto;
			width: 46%;
			height: 60px;
			background: #000;
			line-height: 60px;
			padding: 0 10px;
			box-sizing: border-box;
			cursor: pointer;
		}

		.reservelab>span {
			/* line-height: 96px; */
			margin-left: 12px;
			font-size: 16px;
			font-family: Roboto-Bold, Roboto;
			display: block;
			width: calc(100% - 180px);
		}

		/deep/ .el-form-item__content {
			/* display: flex; */
			/* align-items: center; */
			padding: 10px 16px;
			line-height: 40px;
			font-size: 14px;
			font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
			width: 72%;
			background-color: #fff;
			border-left: 1px solid #ddd;
			min-height: 60px;
		}

		/deep/ .el-form-item:nth-child(1) .el-form-item__content {
			display: block;
			align-items: center;
			padding: 10px 16px;
			line-height: 40px;
			font-size: 14px;
			font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
			width: 72%;
			background-color: #fff;
			border-left: 1px solid #ddd;
			min-height: 60px;
		}

		.reservebox>span {
			width: 30%
		}

		/deep/ .ddd .el-form-item__content span {
			width: 30%;
			display: block;
		}


		/deep/ .el-dialog {
			width: 30%;
		}

		/deep/ .el-icon-close:before {
			font-size: 20px;
			color: #000000;
		}

		.btntext {
			width: calc(100% - 16px);
			text-align: center;
			font-size: 22px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			color: #fff;
			float: right;
			display: block;
		}

	}

	@media only screen and (max-width:850px) {
		.btntext {
			font-size: 20px;
		}
	}

	@media only screen and (max-width:790px) {
		.btntext {
			font-size: 18px;
		}
	}

	@media only screen and (max-width:720px) {
		.btntext {
			font-size: 16px;
		}
	}

	@media only screen and (max-width:680px) {
		.surebg {
			width: 92%;
			margin: 0 auto;
		}

		.reservebg {
			width: 100%;
			margin: 0 auto;
			margin-top: 20px
		}

		.reservetop>p {
			font-size: 30px;
			font-family: Roboto-Bold, Roboto;
			margin-top: 30px
		}

		.carlinbn {
			margin: 60px auto;
			width: 52%;

			background: #000;
			line-height: 60px;
			padding: 0 10px;
			box-sizing: border-box;
			cursor: pointer;
			/* background-color: red; */
			height: 60px;
		}

		.carlinbn img {
			width: 14px;
			height: 14px;
			display: block;
			margin-top: 23px;
			float: right;
		}

		/deep/.el-image {
			width: 140px;
			height: 86px
		}

		.reservelab>span {
			/* line-height: 96px; */
			margin-left: 10px;
			font-size: 14px;
			font-family: Roboto-Bold, Roboto;
			display: block;
			width: calc(100% - 150px);
		}

		/deep/ .el-form-item__content {
			/* display: flex; */
			/* align-items: center; */
			padding: 10px 16px;
			line-height: 40px;
			font-size: 12px;
			font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
			width: 72%;
			background-color: #fff;
			border-left: 1px solid #ddd;
			min-height: 60px;
		}

		/deep/ .reservebox .el-input {
			/* width: 60px !important; */
		}

		.reservebox>span {
			width: 30%;
			font-size: 10px;
			line-height: 15px;
		}

		/deep/ .ddd .el-form-item__content span {
			width: 30%;
			display: block;

			font-size: 10px;
			line-height: 15px;

		}

		/deep/ .ddd .el-form-item__error {
			font-size: 10px;
		}


		/deep/ .el-dialog {
			width: 86%;
		}

		/deep/ .el-icon-close:before {
			font-size: 20px;
			color: #000000;
		}

		.btntext {
			width: calc(100% - 16px);
			text-align: center;
			font-size: 22px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			color: #fff;
			float: right;
			display: block;
		}
	}


	@media only screen and (max-width:550px) {
		.btntext {
			font-size: 18px;
		}
	}

	@media only screen and (max-width:440px) {
		.btntext {
			font-size: 16px;
		}
	}

	@media only screen and (max-width:410px) {
		.btntext {
			font-size: 15px;
		}
	}

	.carlogin {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(221, 221, 221, 0.8000);
		overflow: hidden;
		display: flex;
		align-items: center;
		text-align: center;
		justify-content: center
	}

	.reservetop>span {
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
	}

	.reservelab {
		/* line-height: 96px; */
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}


	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	/deep/ .my-label {
		text-algin: center !important;
		width: 28%
	}

	.el-form {
		border: 1px solid #ddd;
		background-color: #FAFAFA;
	}

	.el-form-item {
		border-bottom: 1px solid #ddd;
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}


	/deep/ .el-form-item__label {
		display: flex;
		align-items: center;
		text-align: center;
		justify-content: center;
		height: 100%;
		background-color: #FAFAFA;
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000;
		height: 60px;
		width: 28%;
		line-height: 1;
	}


	/deep/ .el-radio-button__inner,
	.el-radio-group {
		line-height: 60px;
	}


	/* /deep/ .el-form-item:nth-child(1) .el-form-item__label {
		height: 136px;
	} */

	/deep/ .el-form-item:nth-child(1) .el-form-item__content {
		padding: 20px 16px;
	}

	/* /deep/ .el-form-item:nth-child(14) .el-form-item__content {
		padding: 5px 16px;
	} */

	/* /deep/ .el-form-item:nth-child(14) .el-form-item__label {
		height: 200px;
	} */

	/* /deep/ .el-form-item:nth-child(4) .el-form-item__label {
		height: 120px;
	} */
	.el-form-item:nth-child(13) .el-radio {
		display: block;
		line-height: 32px;
		word-wrap: break-word;
		word-break: break-all;

	}

	.el-form-item:nth-child(15) .el-radio {
		/* display: block; */
		line-height: 32px;
		word-wrap: break-word;
		word-break: break-all;

	}

	/deep/ .el-form-item:nth-child(15) .el-radio__label {
		word-wrap: break-word;
		word-break: break-all;
		width: 100%;
	}

	/deep/ .zysxlabel .el-radio {
		display: block;
		line-height: 32px;
		word-wrap: break-word;
		word-break: break-all;

	}

	/deep/ .zysxlabel .el-radio__label {
		word-wrap: break-word;
		word-break: break-all;
		width: 100%;
	}



	/deep/ .el-form-item:nth-child(17) .el-form-item__content {
		display: block !important;
	}

	/* /deep/ .el-form-item:nth-child(16) .el-form-item__label {
		height: 240px;
	} */

	/* /deep/.tabtop .el-form-item__label {
		height: 560px !important;
	} */



	.graybg {
		background-color: #ddd;
	}

	/deep/ .carlinbn>span {
		width: 100%;
	}


	.carlinbn img {
		width: 14px;
		height: 14px;
		display: block;
		margin-top: 23px;
		float: right;
	}

	/* 按钮容器样式 */
	.carlinbn1 {
		background-color: #000 !important;
		border-color: #000 !important;
		border-radius: 4px;
		/* 可根据需求调整圆角 */
		padding: 12px 24px;
		/* 调整内边距 */
		width: 20%;
		/* 或者指定固定宽度 */
		height: 40px;
		/* 调整高度 */
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.3s ease;
		/* 添加过渡效果 */
	}

	/* 鼠标悬停效果 */
	.carlinbn1:hover {
		background-color: #333 !important;
		/* 悬停时稍亮的黑色 */
		border-color: #333 !important;
		transform: translateY(-2px);
		/* 轻微上浮效果 */
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
		/* 添加阴影 */
	}

	/* 按钮按下效果 */
	.carlinbn1:active {
		transform: translateY(0);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	}

	/* 按钮容器样式 - 横向排列 */
	/* 按钮组容器 - 默认横向靠左排列 */
	.button-group {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		gap: 1200px;
	}

	/* 按钮固定样式 */
	.fixed-button {
		background-color: #000 !important;
		border-color: #000 !important;
		width: 150px;
		/* 固定宽度 */
		height: 40px;
		/* 固定高度 */
		padding: 0;
		/* 移除内边距以保持尺寸精确 */
		margin: 15 !important;
		/* 清除默认边距 */
		margin: 5px;
		padding: 5px;
	}

	/* 按钮文字样式 */
	.button-text {
		font-size: 14px;
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	/* 小屏幕竖排靠左排列 */
	@media (max-width: 768px) {
		.button-group {
			flex-direction: column;
			align-items: flex-start;
			gap: 12px;
			/* 增加垂直间距 */
			margin: 12;
			padding: 12;
			width: 100%;
		}

		/* 确保按钮在小屏幕也保持同样大小 */
		.fixed-button {
			width: 150px;
			height: 40px;
			margin-left: 0 !important;
			/* 确保没有左边距 */
		}
	}

	/* 修复Element UI按钮可能的默认样式 */
	.el-button {
		display: flex;
		justify-content: center;
	}


	/* 调整字体大小 */
	@media (max-width: 480px) {
		.btntext1 {
			font-size: 14px;
		}
	}

	/* 按钮文字样式 */
	.btntext1 {
		width: 100%;
		text-align: center;
		font-size: 15px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #fff !important;
		letter-spacing: 0.5px;
		/* 字母间距 */
		text-transform: uppercase;
		/* 可选：转为大写 */
	}

	/* 移除Element UI按钮的默认样式影响 */
	.carlinbn1.el-button {
		border: none;
		outline: none;
	}

	/* 响应式调整 */
	@media (max-width: 768px) {
		.carlinbn1 {
			height: 50px;
			padding: 10px 20px;
		}

		.btntext1 {
			font-size: 18px;
		}
	}

	.bxtc,
	.bxbg {
		width: 100%;
	}

	.bxtc>p {
		line-height: 30px;
		font-size: 20px;
	}

	.bxtxitem {
		line-height: 35px;
	}

	.bxtxitem p:nth-child(2n-1) {
		margin-right: 40px;
	}

	.bxtxitem span {
		margin-left: 8px;
	}


	/* /deep/ .el-form-item:nth-child(15) .el-form-item__label {
		height: 430px;
	} */

	/deep/.el-form-item:nth-child(16) .el-form-item__content {
		display: flex;
		flex-direction: column;
		/* width: 73%; */
	}

	.bxtxred {
		color: #FF0000;
		font-size: 12px;
		line-height: 20px;
		margin-bottom: 20px;
	}


	/deep/ .el-table_1_column_1 {
		color: #FF0000;
		font-weight: bold;
	}

	/deep/ .el-table_1_column_3 {
		color: #FF0000;
		font-weight: bold;
		font-size: 16px;
	}

	.bxtxredtext {
		color: #FF0000;
		line-height: 20px;
		margin-top: 10px;
		font-size: 12px;

	}

	.image-carousel-wrapper {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}

	/* 新增关闭按钮样式 */
	.close-button {
		position: absolute;
		top: 20px;
		right: 20px;
		background: rgba(255, 255, 255, 0.2);
		color: white;
		border: none;
		width: 40px;
		height: 40px;
		font-size: 24px;
		border-radius: 50%;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1001;
		transition: all 0.3s ease;
	}

	.close-button:hover {
		background: rgba(255, 255, 255, 0.3);
		transform: scale(1.1);
	}

	.image-carousel {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		width: 100%;
		max-width: 800px;
		margin: 0 auto;
	}

	.image-container {
		display: flex;
		overflow: hidden;
		width: 100%;
	}

	.carousel-image {
		width: 100%;
		flex-shrink: 0;
		transition: transform 0.5s ease;
		display: none;
		max-height: 80vh;
		object-fit: contain;
	}

	.carousel-image.active {
		display: block;
	}

	.nav-button {
		background: rgba(0, 0, 0, 0.5);
		color: white;
		border: none;
		padding: 15px 20px;
		cursor: pointer;
		font-size: 24px;
		border-radius: 5px;
		z-index: 10;
		margin: 0 10px;
		transition: all 0.3s ease;
	}

	.nav-button:hover {
		background: rgba(0, 0, 0, 0.8);
		transform: scale(1.1);
	}

	/* 响应式调整 */
	@media (max-width: 768px) {
		.close-button {
			top: 10px;
			right: 10px;
			width: 30px;
			height: 30px;
			font-size: 18px;
		}

		.nav-button {
			padding: 10px 15px;
			font-size: 18px;
		}
	}

	/deep/ .dddtime .el-form-item {
		border: none;
		margin: 0;
		display: flex;
	}

	/deep/ .dddtime .el-form-item .el-form-item__content {
		border: none;
		padding: 0;
	}

	/deep/ .dddtime .yxtime .el-form-item .el-form-item__content {
		display: block !important;
		line-height: 60px;
	}

	/deep/ .dddtime .el-input__inner {
		margin-top: 10px;
	}

	/deep/ .ddd .el-form-item__error {
		width: 27%;
	}


	/* 原有按钮样式保持不变 */
	.play-button {
		background-color: #000;
		border-color: #000;
		color: white;
		padding: 12px 24px;
		border-radius: 4px;
		cursor: pointer;
	}

	.button-text {
		font-size: 16px;
	}

	/* 视频容器样式 - 添加半透明背景 */
	.video-container {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(0, 0, 0, 0.8);
	}

	.video-wrapper {
		width: 100%;
		height: 100%;
		max-width: 100%;
		max-height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.responsive-video {
		max-width: 100%;
		max-height: 100%;
		width: auto;
		height: auto;
		background-color: #000;
		cursor: pointer;
	}

	.loading-indicator {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: white;
		text-align: center;
		font-size: 16px;
	}

	.loading-icon {
		font-size: 32px;
		margin-bottom: 12px;
		display: block;
		animation: rotating 2s linear infinite;
	}

	/* 全局弹窗样式 - 修改为半透明黑色背景 */
	.video-dialog {
		margin: 0 !important;
		max-width: 100vw !important;
		max-height: 100vh !important;
		display: flex;
		flex-direction: column;
		background: rgba(0, 0, 0, 0.8) !important;
		backdrop-filter: blur(5px);
	}

	.video-dialog .el-dialog__header {
		padding: 12px;
		background: transparent !important;
		border-bottom: none;
	}

	.video-dialog .el-dialog__headerbtn {
		top: 12px;
		right: 12px;
		color: white;
		font-size: 24px;
	}

	.video-dialog .el-dialog__headerbtn:hover {
		color: #ddd;
	}

	.video-dialog .el-dialog__body {
		flex: 1;
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden;
		background: transparent !important;
	}

	/* 覆盖层半透明黑色背景 */
	.el-overlay {
		background-color: rgba(0, 0, 0, 0.8) !important;
		backdrop-filter: blur(5px);
	}
</style>